import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const reloadChannel = new BroadcastChannel('reload');

export const BroadcastLayer = () => {
	const navigate = useNavigate();
	useEffect(() => {
		reloadChannel.onmessage = () => navigate(0);
	}, []);

	return null;
};
